module.exports = __webpack_public_path__ + "static/media/loginimage.6c165cdd.svg";